export const TITLE_PREFIX = 'Fulfillments > InterOffice';
export const DOMAIN_NAME = 'interofficeMailFulfillment';
export const WORKFLOW_NAME = 'InterofficeMail';

export const DASHBOARD_ROUTE = '/inter-office/main';
export const PICK_ROUTE = '/inter-office/pick';
export const GROUP_PICK_ROUTE = '/inter-office/group-pick';
export const WAVES_ROUTE = '/inter-office/waves';
export const WAVES_HISTORY_ROUTE = '/inter-office/waves-history';
export const PACK_ROUTE = '/inter-office/pack';
export const READY_FOR_PICKUP_ROUTE = '/inter-office/shipped';
export const HOSPITAL_ROUTE = '/inter-office/hospital';
export const CANCEL_ROUTE = '/inter-office/cancel';
export const CANCELLED_ROUTE = '/inter-office/cancelled';
export const FINALIZED_ROUTE = '/inter-office/finalized';

export const ORDER_DETAILS_ROUTE = '/orders';
export const PRODUCTS_DETAILS_ROUTE = '/products/overview';
export const USERS_DETAILS_ROUTE = '/users';
export const DETAILS_ROUTE = '/inter-office/details';
export const GROUP_PICK_DETAILS_ROUTE = '/inter-office/group-pick-details';
export const PICKING_ROUTE = '/inter-office/picking';
export const GROUP_PICKING_ROUTE = '/inter-office/group-picking';
export const PACKING_ROUTE = '/inter-office/packing';

export const STATES = {
    pick: 'pick',
    pack: 'pack',
    hospital: 'hospital',
    ready: 'ready',
    finalized: 'finalized',
    cancelled: 'cancelled',
};

export const GROUP_STATES = {
    notPicked: 'not_picked',
    partialPicked: 'partial_picked',
    picked: 'picked',
};
